import { FIRESTORE_COLLECTIONS } from '@core/constants/collections.constants';
import jsonHelper from '@core/helpers/jsonHelper';
import firebase from '@core/settings/firebase-settings';
import { child, get, ref, set } from 'firebase/database';
import { v4 as uuidv4 } from 'uuid';

import { TextContent } from './text-content.model';

export default class TextContentRepository {
  private db = firebase.realtimedb;
  private collectionName = FIRESTORE_COLLECTIONS.TEXT_CONTENTS;

  private getPath(name: string) {
    return `${this.collectionName}/${name.replace('.', '_')}`;
  }

  async add(entity: TextContent) {
    const new_uuid = uuidv4();
    const createdAt = Date.now();
    entity.id = new_uuid;
    entity.createdAt = createdAt;
    entity.updatedAt = createdAt;

    try {
      const textRef = ref(this.db, this.getPath(entity.name));
      set(textRef, entity);
      return true;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async remove(name: string) {
    const textRef = ref(this.db, this.getPath(name));
    set(textRef, null);
  }

  async getByName(name: string) {
    const textRef = ref(this.db, this.collectionName);
    var snapshot = await get(child(textRef, name.replace('.', '_')));
    if (!snapshot.exists()) {
      return undefined;
    }
    return jsonHelper.castTo<TextContent>({ ...snapshot.val(), id: snapshot.key });
  }

  validator(entity: TextContent, action: 'add') {
    return new Promise<boolean | string>(async (resolve, reject) => {
      if (entity.name === '' || entity.name.length <= 3) return reject('Preencha o campo nome');
      if (entity.content === '' || entity.content.length <= 3) return reject('Preencha o conteúdo');

      if (action === 'add') {
        const r = await this.getByName(entity.name);
        if (r) {
          return reject('O nome informado já está cadastrado');
        }
      }

      return resolve(true);
    });
  }
}
